module.exports = __webpack_public_path__ + "static/media/logo.ed5bce84.svg";